import React, { useState, useEffect } from "react";

import styles from "./tab-screen-one.module.scss";

export default function TabScreenOne(props) {
  const [state, setState] = useState({});

  useEffect(() => {}, []);

  return (
    <main className={styles.tab_screen_one_container}>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam ut sint,
      distinctio dolorum est explicabo consequuntur doloremque harum aspernatur,
      adipisci fugit? Autem consequuntur eveniet ad cumque reprehenderit saepe
      ducimus error. Amet porro at aperiam expedita laborum voluptatibus
      placeat, autem minima provident est vitae repellendus, pariatur deserunt!
      Repudiandae, ipsum quae non omnis dolore ea aliquam iste veritatis? Nemo
      id voluptatum cumque! Non saepe alias facilis. Laboriosam, alias. Minus,
      veniam, eum a consequatur fugiat quibusdam tenetur numquam ratione quam
      ullam doloribus velit porro rerum debitis mollitia. Nulla earum molestiae
      aliquam sint modi? Ad earum veniam exercitationem velit vero minima ex
      ratione at quam eveniet minus, commodi ipsa dolores! Quis, velit. Voluptas
      placeat dolor maxime? Numquam, eaque mollitia consequatur ratione
      aspernatur error eveniet. Quisquam quae omnis vero voluptate itaque minima
      hic asperiores corporis odit! Quidem distinctio eius hic, iusto
      necessitatibus laboriosam nemo. Autem dolorum iure dolores, earum sequi
      ipsa similique distinctio sunt consectetur. Eveniet in obcaecati quo
      corporis, accusantium nemo ipsum repellat aliquam, voluptatum provident
      ducimus quasi autem unde libero expedita incidunt reiciendis quis deleniti
      molestias? Nesciunt recusandae eveniet sequi quaerat aliquid animi.
    </main>
  );
}
